import { useCallback, useEffect, useState } from "react";
import { accountApi } from "../utils/workspacesApi";



export const useCurrentUser = (cookieUser, { enabled = true } = {}) => {
    const [user, setUser] = useState(cookieUser);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState(null);

    const fetchUser = useCallback(async () => {
        if (!enabled) { setLoading(false); return; }
        setError(null);
        try {
            const data = await accountApi.getMe();

            let resolvedTier = data.tier;


            if (data.userType === "org_corporate" || data.userType === "org_brokerage") {
                try {
                    const plan = await accountApi.getMyPlan();
                    if (plan?.tier && plan.tier !== data.tier) {
                        console.warn(
                            `[useCurrentUser] /me tier ("${data.tier}") disagrees with /me/plan tier ("${plan.tier}") for user ${data.id}. Trusting /me/plan.`
                        );
                        resolvedTier = plan.tier;
                    }
                } catch {
                    // If /me/plan fails, fall back to whatever /me said rather than
                    // blocking the whole user object on a second endpoint.
                }
            }

            setUser((prev) => ({ ...prev, ...data, tier: resolvedTier }));
        } catch (err) {
            setError(err.message || "Failed to load account details.");
        } finally {
            setLoading(false);
        }
    }, [enabled]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return { user, loading, error, refetch: fetchUser };
};

export default useCurrentUser;